/**
 * The artwork credit (RA-2695, handoff §10 item 7), shared by the splash cover, the Library hero and the
 * editor's Preview. Rendered as `Artwork by <b>{artist}</b>` plus an optional parenthetical.
 */
export interface SplashCredit {
  /** The artist exactly as given — never validated, case-fixed or abbreviated beyond a whitespace trim. */
  artist: string;
  /** `(grade)` after the name, when there is a grade but no credit note. */
  inline?: string;
  /** `(grade | Note)` on its own row, whenever a credit note is present. */
  secondRow?: string;
}

/**
 * Composes the credit. With a note: a second row `(grade | Note)` — the note's first letter capitalised and
 * one trailing full stop removed, the grade omitted from the join when blank. Without one: `(grade)` inline,
 * or nothing.
 */
export function splashCredit(artist: string | null | undefined, grade: string | null | undefined,
                             family: string | null | undefined): SplashCredit {
  const credit: SplashCredit = { artist: (artist ?? '').trim() };
  const gradeText = (grade ?? '').trim();
  const note = (family ?? '').trim();
  if (note) {
    const capitalised = (note.charAt(0).toUpperCase() + note.slice(1)).replace(/\.$/, '');
    credit.secondRow = `(${[gradeText, capitalised].filter(Boolean).join(' | ')})`;
  } else if (gradeText) {
    credit.inline = `(${gradeText})`;
  }
  return credit;
}
